import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import DeleteDialogModal from "../../control-components/custom-delete-dialog-box/delete-dialog";
import Loader from "../../control-components/loader/loader";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { MaskFormatted } from "../../helper/mask-helper";
import { AdminService } from "../../services/adminService";
import { Encrption } from "../encrption";
import AddAdminUser from "./add-admin-user";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

function AdminUser() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isAddAdmin, setAddAdmin] = useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [adminsListing, setAdminUsers] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);

  useEffect(() => {
    getAdminUsers();
  }, []);

  const handleAddAdmin = () => {
    setAddAdmin(true);
  };

  const handleCloseAdmin = ({ updated }) => {
    if (updated) {
      getAdminUsers();
    }
    setAddAdmin(false);
  };

  const getAdminUsers = async () => {
    setLoading(true);
    await AdminService.getAdmins()
      .then((result) => {
        setAdminUsers(result.resultData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };

  const AdminUserDelete = async () => {
    setLoading(true);
    await ApiHelper.deleteRequest(
      ApiUrls.ADMIN_USER_DELETE + Encrption(selectedId)
    )
      .then((result) => {
        NotificationManager.success("Admin user deleted successfully.");
        setLoading(false);
        setDeleteConfirm(!isDeleteConfirm);
        getAdminUsers();
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };

  const handleDelete = () => {
    setDeleteConfirm(!isDeleteConfirm);
  };

  const deleteSelectId = (id) => {
    setDeleteConfirm(true);
    setSelectedId(id);
  };

  const editSelectId = (id) => {
    setSelectedId(id);
    setAddAdmin(true);
  };

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2" >
        <h4 className="address-title text-grey ">
          <span className="f-24 mt-3">Admin Users</span>
        </h4>
        <button onClick={handleAddAdmin} className="green-btn btn-primary">
          <span class="fa fa-plus" style={{ color: "#fff" }}></span> Add Admin
        </button>
      </div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading ?
                  <Loader /> :
                  <Grid
                    data={orderBy(
                      adminsListing.slice(page, pageSize + page),
                      sort
                    ).map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    checkboxElement
                    style={{
                      height: adminsListing.length > 0 ? "100%" : "250px",
                    }}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    skip={page}
                    take={pageSize}
                    total={adminsListing.length}
                    onPageChange={pageChange}
                    pageable={{
                      pageSizes: [10, 20, 30],
                    }}
                    sort={sort}
                    sortable={true}
                    onSortChange={(e) => {
                      setSort(e.sort);
                    }}
                    scrollable="none"
                  >
                    <GridNoRecords style={{}}></GridNoRecords>
                    {/* <GridColumn filterable={false} field={SELECTED_FIELD} width="100px" /> */}
                    <GridColumn
                      className="cursor-default"
                      field="firstName"
                      title="First Name"
                      width="300px"
                      max-width="30px"
                      min-width="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="lastName"
                      title="Last Name"
                      width="300px"
                      max-width="30px"
                      min-width="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="email"
                      title="Email"
                      width="300px"
                      max-width="30px"
                      min-width="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="mobile"
                      title="Mobile"
                      width="300px"
                      max-width="30px"
                      min-width="150px"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.mobile;
                          return <td>{MaskFormatted(field, "(999) 999-9999")}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      title="Action"
                      width="300px"
                      max-width="30px"
                      min-width="150px"
                      filterable={false}
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.id;
                          return (
                            <td>
                              <div className="row-3">
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                  onClick={() => deleteSelectId(field)}
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                        title="Delete"
                                      ></i>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                  onClick={() => editSelectId(field)}
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i className="fas fa-edit" title="Edit"></i>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                              {/* <span className='k-icon k-i-delete text-danger' onClick={() => deleteAuth(field)} />
                            <span style={{ marginLeft: '20px' }} className='k-icon k-i-edit' onClick={() => editAuth(field)} /> */}
                            </td>
                          );
                        }
                      }}
                    />
                  </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAddAdmin && (
        <AddAdminUser onClose={handleCloseAdmin} selectedId={selectedId} />
      )}
      {isDeleteConfirm && (
        <DeleteDialogModal
          onClose={handleDelete}
          title="Admin"
          message="admin"
          handleDelete={AdminUserDelete}
        />
      )}
    </>
  );
}
export default AdminUser;
